function add_to_cart(e) {
    jQuery.ajax({ type: "POST", url: "/cart/add.js", data: { id: e, quantity: 1 }, dataType: "json", success: function () {} });
}
document.addEventListener("DOMContentLoaded", () => {
    if (
        ($(".home-slider") &&
            $(".home-slider").slick({
                infinite: !0,
                slidesToShow: 4,
                slidesToScroll: 1,
                adaptiveHeight: !0,
                prevArrow: `<button class="prev">
      <svg width="13" height="24" viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.9014 1.19775L1.00014 12.099L11.9014 23.0002" stroke="#075EC7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      </button>`,
                nextArrow: `<button class="next">
      <svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.90112 22.8022L12.8024 11.901L1.90112 0.999788" stroke="#075EC7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      </button>`,
                dots: !0,
                responsive: [
                    { breakpoint: 1200, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                    { breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 1 } },
                    { breakpoint: 767, settings: { slidesToShow: 1 } },
                ],
            }),
        document.querySelector(".home-about"))
    ) {
        var e = document.querySelector(".home-about"),
            o = document.querySelector(".about-home__img--text"),
            t = document.querySelector(".about-home__img--left"),
            s = document.querySelector(".about-home__img--clouds");
        function i(e) {
            let o = e.getBoundingClientRect(),
                t = window.pageXOffset || document.documentElement.scrollLeft,
                s = window.pageYOffset || document.documentElement.scrollTop;
            return { top: o.top + s, left: o.left + t };
        }
        function l() {
            let l = e.offsetHeight,
                r = i(e).top,
                d = window.innerHeight - l / 1;
            pageYOffset > r - d && pageYOffset < r + l ? (o.classList.add("active"), t.classList.add("active"), s.classList.add("active")) : (o.classList.remove("active"), t.classList.remove("active"), s.classList.remove("active")),
                console.log(r);
        }
        window.addEventListener("scroll", l);
    }
    if (
        ($(".sliderTop") &&
            $(".sliderBottom") &&
            ($(".sliderTop").slick({ slidesToShow: 1, slidesToScroll: 1, arrows: !1, fade: !0, asNavFor: ".sliderBottom" }), $(".sliderBottom").slick({ slidesToShow: 4, slidesToScroll: 1, asNavFor: ".sliderTop", focusOnSelect: !0 })),
        document.querySelector("#isRead"))
    ) {
        let r = document.querySelector("#isRead"),
            d = document.querySelector(".btn--contact");
        d.setAttribute("disabled", !0),
            r.addEventListener("click", () => {
                r.checked ? d.removeAttribute("disabled") : d.setAttribute("disabled", !0);
            });
    }
    $(".nav-hide__close").on("click", function () {
        $(".nav-hide").removeClass("active"), $("html,body").removeClass("overflow_hidden");
    }),
        $(".mob-btn").on("click", function () {
            $(".nav-hide").addClass("active"), $("html,body").addClass("overflow_hidden");
        }),
        $(".show_sub_menu").on("click", function () {
            var e = $(this).attr("id");
            $(".header_sub_menu").removeClass("mob_active"), $("#" + e + "-menu").addClass("mob_active");
        }),
        $(".show_sub_sub_menu").on("click", function () {
            var e = $(this).attr("id");
            $(".header_sub_sub_menu").removeClass("mob_active"), $("#" + e + "-menu").addClass("mob_active");
        }),
        $(".goto_mob_menu").click(function () {
            $(".header_sub_menu").removeClass("mob_active");
        }),
        $(".goto_mob_submenu").click(function () {
            $(".header_sub_sub_menu").removeClass("mob_active");
        });
}),
    jQuery(document).ready(function (e) {
        if (e(".product_slider_main")) {
            var o = e(".product_slider_main").data("current"),
                t = e(".product_slider_main").data("count");
            e(".product_slider_main").slick({ slidesToScroll: 1, slidesToShow: 1, arrows: !1, dots: !1, autoplay: !1, infinite: !1, speed: 600, focusOnSelect: !0, initialSlide: o, asNavFor: ".product_slider_thumbail" });
            var s = !0;
            t < 4 && (s = !1),
                e(".product_slider_thumbail").slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    asNavFor: ".product_slider_main",
                    arrows: true,
                    dots: false,
                    initialSlide: o,
                    infinite: !1,
                    focusOnSelect: !0,
                  adaptiveHeight: true,
                    responsive: [
                        { breakpoint: 600, settings: { dots: false, slidesToShow: 3 } },
                        { breakpoint: 400, settings: { dots: false, slidesToShow: 2 } },
                    ],
                });
        }
        e(".product_slider_main") &&
            e(".product-recommendations-slider").slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                infinite: !1,
                focusOnSelect: !0,
                responsive: [
                    { breakpoint: 600, settings: { dots: false, slidesToShow: 3 } },
                    { breakpoint: 400, settings: { dots: false, slidesToShow: 2 } },
                ],
            });
    });
